// Theme preference from the profile menu; static/theme-init.js applies a pinned value before first paint.

export type ThemePreference = 'system' | 'light' | 'dark';

const STORAGE_KEY = 'platform:theme';
const ROOT_CLASS = { light: 'themeLight', dark: 'themeDark' } as const;

/** Narrows a stored value to a preference; anything unexpected follows the OS. */
export function parseTheme(value: string | null): ThemePreference {
	return value === 'light' || value === 'dark' ? value : 'system';
}

function readStored(): ThemePreference {
	try {
		return parseTheme(localStorage.getItem(STORAGE_KEY));
	} catch {
		return 'system';
	}
}

function apply(preference: ThemePreference): void {
	const root = document.documentElement;
	root.classList.remove(ROOT_CLASS.light, ROOT_CLASS.dark);
	if (preference !== 'system') root.classList.add(ROOT_CLASS[preference]);
	document
		.querySelector('meta[name="color-scheme"]')
		?.setAttribute('content', preference === 'system' ? 'light dark' : preference);
}

class ThemeStore {
	preference = $state<ThemePreference>(
		typeof localStorage === 'undefined' ? 'system' : readStored()
	);

	set(preference: ThemePreference): void {
		this.preference = preference;
		try {
			if (preference === 'system') localStorage.removeItem(STORAGE_KEY);
			else localStorage.setItem(STORAGE_KEY, preference);
		} catch {
			// Storage blocked: the choice lasts for this page only.
		}
		apply(preference);
	}
}

export const themeStore = new ThemeStore();
